import { Moment } from "moment";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "types";
import { DescriptorColorType } from "types/generics";
import "./card.scss";

function Card({
    clipId,
    streamId,
    authorName,
    datePosted,
    body,
    link,
    impactScore,
    ave,
    showComments,
}: {
    clipId?: string;
    streamId: number;
    authorName: string;
    datePosted: Moment;
    body: string;
    link?: string;
    impactScore?: number;
    ave?: number;
    showComments?: boolean;
}) {
    const state = useSelector((state: RootState) => state);
    const [stream, setStream] = useState<DescriptorColorType>(state.core.Stream.find((x) => x.Id === streamId) || { Color: "#A0A0A0", Description: "Unknown", Id: 0 });
    const [comment, setComment] = useState("");
    const [commentsOpen, setCommentsOpen] = useState(false);

    // const getComments = useCallback(async () => {
    //     if (clipId) {
    //         const accessTokens = await api.accessToken.getAll(project.Id);
    //         const validAccessTokens : any[] = accessTokens.filter((x: any) => x.StreamId === 9 && x.AccessToken !== '');
    //         if (validAccessTokens.length) {
    //             const res = await fetch(`https://graph.facebook.com/v12.0/${clipId}/comments?access_token=${validAccessTokens[0].AccessToken}`);
    //             const data = await res.json();
    //             console.log(data);
    //         }
    //     }
    // }, [clipId, project.Id])

    useEffect(() => {
        setStream(state.core.Stream.find((x) => x.Id === streamId) || { Color: "#A0A0A0", Description: "Unknown", Id: 0 });
    }, [state.core.Stream, streamId]);

    const getStreamName = useCallback((streamId) => {
        switch (streamId) {
            case 7:
                return "x-twitter";
            case 8:
                return "facebook";
            case 9:
                return "instagram";
            case 10:
                return "youtube";
            case 11:
                return "linkedin";
            case 12:
                return "tiktok";
        }
    }, []);

    return (
        <div className="card">
            <div className="card-header">
                <i className={`fab fa-${getStreamName(stream.Id)}`}></i>
                <span className="card-author">{authorName}</span>
                <span className="card-date">{datePosted.format("DD MMM YYYY - HH:mm")}</span>
            </div>
            <div className="card-body">
                <p>{body}</p>
            </div>
            <div className="card-footer">
                {impactScore && (
                    <span className="impact-score" title="Impact score">
                        <i className="fal fa-trophy-alt"></i> {impactScore}
                    </span>
                )}
                {ave && (
                    <span className="ave" title="AVE">
                        R {ave}
                    </span>
                )}
                {showComments && <i className="fal fa-comments" onClick={() => setCommentsOpen(!commentsOpen)}></i>}
                {link && <i className="fal fa-share" onClick={() => window.open(link, "_blank")}></i>}
            </div>
            <div className={`card-comments${commentsOpen ? " open" : ""}`}>
                <textarea value={comment} rows={4} onChange={(e) => setComment(e.currentTarget.value)}></textarea>
            </div>
        </div>
    );
}

export default Card;
